<div class="notificationo-dialog">
	<div tourAnchor="notification-view" class="drawer-top" style="max-width: 300px; min-width: 300px; width: auto; padding: 0px !important; margin: 0px !important">
		<div class="image-section" color="primary">
			<div class="__content">
				<div class="notification-channel">
					<img [src]="notification?.channel?.image?.url || './assets/images/default.png'" alt="" />
					<h3>
						{{ notification?.channel?.name | slice : 0 : 20 }}
						<span *ngIf="maxChar">...</span>
					</h3>
				</div>
				<div class="notification-image" *ngIf="notification?.image && notification?.image?.url">
					<img [src]="notification?.image?.url" />
				</div>
				<div class="notification-title">
					<h2>
						{{ notification?.title }}
					</h2>
				</div>
				<div class="notification-details">
					<h5>
						{{ notification?.message }}
					</h5>
				</div>
				<div *ngIf="notification?.cta" class="notification-details cta">
					<h2>
						{{ notification?.cta }}
					</h2>
					<fa-icon icon="video"></fa-icon>
				</div>
				<div class="notification-actions">
					<div class="icons" *ngIf="notification?.reactions">
						<div *ngFor="let reaction of notification?.reactions">
							<div class="icon">
								<h2>{{ reaction.icon }}</h2>
							</div>
						</div>
					</div>
					<div class="other-actions">
						<div class="other-icon" *ngIf="notification?.allow_video_feedback">
							<button [disableRipple]="true" mat-icon-button>
								<mat-icon>videocam</mat-icon>
							</button>
						</div>
						<div class="other-icon" *ngIf="notification?.external_url_name">
							<button [disableRipple]="true" mat-icon-button style="height: 20px; flex-shrink: 0; line-height: 20px">
								<h5>
									<a target="_blank" href="{{ notification?.external_url }}">
										{{ notification?.external_url_name }}
									</a>
								</h5>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
